(function () {
  'use strict';

  angular
    .module('app.page-project-indicator-templates', []);
})();
